module.exports = __webpack_public_path__ + "static/media/vanilla-profile3.b45867b0.png";